import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { changeDatesToUTC } from "../utils/dateUtils";
import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { queryClient } from "../App";
import { API_URL } from "../consts";
import { useSnackbar } from "notistack";
import { Button, DialogActions, DialogContent, Grid, TextField } from "@mui/material";
import { RisorseTipologie } from "../prismaTypes";

type Inputs = {
  definizione: string;
};

export function EditSpecifica(props: { tipologia?: RisorseTipologie; handleClose: () => void }) {
  const { tipologia, handleClose } = props;
  const { enqueueSnackbar } = useSnackbar();

  const schema = yup
    .object({
      definizione: yup.string().max(50).required(),
    })
    .required();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>({
    mode: "all",
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: Inputs) => {
    changeDatesToUTC(data);
    if (tipologia) mutateUpdate(data);
    else mutate(data);
  };

  const { mutate } = useMutation(
    (data: Inputs) => {
      return axios.put(API_URL + "risorse/specifica", data);
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Tipologia creata", { variant: "success" });
        handleClose();
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  const { mutate: mutateUpdate } = useMutation(
    (data: Inputs) => {
      return axios.patch(API_URL + "risorse/specifica/" + tipologia?.id, data);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Specifica aggiornata", { variant: "success" });
        handleClose();
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    }
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DialogContent>
        <Grid container rowSpacing={1} columnSpacing={1}>
          <Grid item xs={12}>
            <Controller
              name="definizione"
              control={control}
              defaultValue={tipologia?.definizione ?? ""}
              render={({ field }) => (
                <TextField
                  {...field}
                  required
                  fullWidth
                  variant="standard"
                  label="Definizione"
                  error={Boolean(errors.definizione)}
                  helperText={errors.definizione?.message ?? ""}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleClose()}>Chiudi</Button>

        {!tipologia && <Button type="submit">Crea Specifica</Button>}

        {tipologia && <Button type="submit">Modifica Specifica</Button>}
      </DialogActions>
    </form>
  );
}
